'use client';

import dynamic from 'next/dynamic';
import { Modals } from '@/helpers/modals';
import { Modal, type ModalProps } from '../Modal';
import { Loader } from '../profile/LoaderWrapper';
import { useDialogs, useDialogsPreloading } from './hooks';

const PRELOADED_MODALS = [Modals.Registration, Modals.Login];

export interface DialogComponentProps {
  onClose?: () => void;
}

interface DialogsProps {
  containerProps?: ModalProps;
  componentProps?: DialogComponentProps;
}

const Dialogs: React.FC<DialogsProps> = ({
  containerProps,
  componentProps,
}) => {
  const { modal } = useDialogs();

  const modalsCache =
    useDialogsPreloading<DialogComponentProps>(PRELOADED_MODALS);

  if (modal) {
    if (!modalsCache.has(modal)) {
      modalsCache.set(
        modal,
        dynamic<DialogComponentProps>(
          () => import(`@/components/dialogs/${modal}`),
          {
            ssr: false,
            loading: () => <Loader size={50} />,
          }
        )
      );
    }

    const Component = modalsCache.get(modal)!;

    return (
      <Modal {...containerProps}>
        <Component {...componentProps} />
      </Modal>
    );
  }
  return null;
};

export default Dialogs;
